import { GENERAL_INFO_SECTION_ID } from 'modules/planning/components/PeriodWizard/steps/sections'

export const createGeneralInfoWizardStep = (translations: {
  generalInfoStepTitle: () => string
  next: () => string
}) => ({
  title: translations.generalInfoStepTitle(),
  nextLabel: translations.next(),
  sectionIds: [GENERAL_INFO_SECTION_ID],
})
